import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { CommonPagesService } from '../../common-pages.service';
import { ResponseStatus, ValidationMessage } from '../../enum';

@Component({
  selector: 'app-add-update-badge',
  templateUrl: './add-update-badge.component.html',
  styleUrls: ['./add-update-badge.component.scss'],
  standalone: false,
})
export class AddUpdateBadgeComponent implements OnInit {
  isVisibleBadgeDrawer = true;
  badgeDrawerTitle = 'Add Badge';
  isLoadingUpload = false;
  isLoadingOne = false;
  darkColorStyle: any;
  lightColorValidationColor: any;
  darkColorValidationColor: any;
  lightColorStyle: any;
  uploadResult: any = null;
  uploadFlag: any = false;
  @Output() hideBadgeDrawer = new EventEmitter();
  @Input() selectedBadgeData: any;
  @Input() transactionType: any;
  url: any;
  validationMessage = ValidationMessage;
  deleteIcon: any;
  userDetails: any;

  constructor(
    public _cs: CommonService,
    private _ws: CommonPagesService,
    public _fS: FormService,
    private msg: NzMessageService
  ) {
    _fS.badgeForm_fb();
  }

  ngOnInit(): void {
    if (this.selectedBadgeData != null) {
      this.badgeDrawerTitle =
        'Edit Badge (' + this.selectedBadgeData.name + ')';
      this._fS.badgeForm.patchValue({
        badgeName: this.selectedBadgeData.name,
        color: this.selectedBadgeData.color,
      });
      this.lightColorStyle = this._fS.badgeForm.value.color;
    }
  }

  applyColorlightColor() {
    this.lightColorStyle = this._fS.badgeForm.value.color;
  }

  //cancel update Agency
  handleCancel(data?: any) {
    this.isVisibleBadgeDrawer = false;
    this.hideBadgeDrawer.emit({
      hide: this.isVisibleBadgeDrawer,
      data: data ? data : null,
    });
  }

  //add/update Agency
  handleOk() {
    if (this._fS.badgeForm.valid) {
      const formValue = this._fS.badgeForm.value;
      var badgeBody = {
        id: this.selectedBadgeData != null ? this.selectedBadgeData.id : '',
        name: formValue.badgeName.trim(),
        color: formValue.color,
        transactionType: this.transactionType,
        orderNo: this.selectedBadgeData ? this.selectedBadgeData.orderNo : 1,
      };

      this.addUpdateBadgeData(badgeBody);
    } else {
      //to fire validations on invalid fields
      Object.values(this._fS.badgeForm.controls).forEach((control: any) => {
        if (control.invalid) {
          control.markAsDirty();
          // this.darkColorValidationColor =
          //   this._fS.badgeForm.controls.darkColor.status;
          this.lightColorValidationColor =
            this._fS.badgeForm.controls.color.status;
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  //api call to add/update agency
  addUpdateBadgeData(badgeBody: any) {
    this.isLoadingOne = true;
    // badgeBody = JSON.stringify(badgeBody)
    this._ws.AddOrUpdateBAdges(badgeBody).subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this._cs.displayMessage('success', response.message);

        this.handleCancel(response.result);
        this.isLoadingOne = false;
      } else {
        this._cs.displayMessage('error', response.message);
        this.isLoadingOne = false;
      }
    });
  }
}
